import request from '../request'

/**
 * 新增待办事项
 */
export function todoAdd(data) {
    return request({
        url: '/common-service/todo/add',
        method: 'POST',
        data
    })
}

/**
 * 批量新增待办事项
 */
export function todoBatchAdd(data) {
    return request({
        url: '/common-service/todo/batchAdd',
        method: 'POST',
        data
    })
}

/**
 * 批量完成待办事项
 */
export function todoBatchComplete(data) {
    return request({
        url: '/common-service/todo/batchComplete',
        method: 'POST',
        data
    })
}

/**
 * 批量更新待办事项状态
 */
export function todoBatchUpdate(data) {
    return request({
        url: '/common-service/todo/batchUpdate',
        method: 'POST',
        data
    })
}

/**
 * 取消待办 (按业务id/业务子id将该业务下未关闭的待办全部置为已关闭)
 */
export function todoCancel(data) {
    return request({
        url: '/common-service/todo/cancel',
        method: 'POST',
        data
    })
}

/**
 * 事项完成 (按业务id/业务子id查询最新一条待处理/待审批，校验处理人后更新为已完成)
 */
export function todoComplete(data) {
    return request({
        url: '/common-service/todo/complete',
        method: 'POST',
        data
    })
}

/**
 * 查询待办事项列表 (处理人、标签多选、状态)
 * @param {Object} params 查询参数
 */
export function todoList(params) {
    return request({
        url: '/common-service/todo/list',
        method: 'POST',
        data: params
    })
}

/**
 * 更新待办事项状态 (按业务id/业务子id查询最新一条待处理/待审批，校验处理人)
 */
export function todoUpdate(data) {
    return request({
        url: '/common-service/todo/update',
        method: 'POST',
        data
    })
}

/**
 * 待办清单汇总（按日期查询我的会议、出差、公出）
 */
export function todoCalendar(params) {
    return request({
        url: '/common-service/todoList/calendar',
        method: 'GET',
        params // get查询参数用params，会拼在url后面 ?startDate=xxx&endDate=xxx
    })
}


/**
 * /todoList/statistics
 * 待办统计（我的待办数量、待我审批数量、今日会议数量）
 */
export function todoStatistics(params) {
    return request({
        url: '/common-service/todoList/statistics',
        method: 'GET',
        params // get查询参数用params，会拼在url后面 ?startDate=xxx&endDate=xxx
    })
}

/**
 * /todoList/add
 * 新增待办清单
 */
export function todoListAdd(data) {
    return request({
        url: '/common-service/todoList/add',
        method: 'POST',
        data
    })
}

/**
 * /todoList/delete
 * 删除待办清单
 */
export function todoListDelete(data) {
    return request({
        url: '/common-service/todoList/delete',
        method: 'POST',
        data
    })
}

/**
 * /todoList/update
 * 更新待办清单
 */
export function todoListUpdate(data) {
    return request({
        url: '/common-service/todoList/edit',
        method: 'POST',
        data
    })
}
